/**
 * Persistent A.I. brand mark — the "memory ring".
 * An open recall loop around a core node, with a satellite memory dot
 * completing the loop: memory captured, held, and recalled.
 */
export const BrandMark = ({ className = "h-9 w-9", title = "Persistent A.I.", testId = "brand-mark" }) => (
  <svg
    viewBox="0 0 48 48"
    className={className}
    role="img"
    aria-label={title}
    data-testid={testId}
  >
    <defs>
      <linearGradient id="pai-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#0E2523" />
        <stop offset="1" stopColor="#0A1420" />
      </linearGradient>
      <linearGradient id="pai-ring" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#5EEAD4" />
        <stop offset="1" stopColor="#14B8A6" />
      </linearGradient>
    </defs>
    <rect x="1" y="1" width="46" height="46" rx="12" fill="url(#pai-bg)" stroke="#14B8A6" strokeOpacity="0.45" />
    {/* open recall loop (gap at top-right) */}
    <circle
      cx="24" cy="24" r="12.5"
      fill="none" stroke="url(#pai-ring)" strokeWidth="3.2" strokeLinecap="round"
      strokeDasharray="63 15.5"
    />
    {/* core memory node + halo */}
    <circle cx="24" cy="24" r="8" fill="#2DD4BF" opacity="0.16" />
    <circle cx="24" cy="24" r="4.6" fill="#2DD4BF" />
    {/* satellite dot completing the loop */}
    <circle cx="34" cy="16.6" r="2.8" fill="#99F6E4" />
  </svg>
);
